import { Divisor } from 'components';

import * as S from './styles';

const PageHeader: React.FC = ({ children }) => {
  return (
    <S.Container data-testid="pageHeaderContainer">
      <S.ContentWrapper>{children}</S.ContentWrapper>
      <Divisor />
    </S.Container>
  );
};

export default PageHeader;
